import React, { useState } from 'react';
import type { Dispatch} from 'umi';
import { connect, useIntl } from 'umi';
import IconFont from '@/components/IconFont';
import TextArea from 'antd/lib/input/TextArea';
import { message, Modal, Space, Upload } from 'antd';

import type { InquiryState } from '@/models/inquiry';
import styles from './index.less';
import { withModalRootContainer } from '@/providers/AntdProvider';

interface InquirySenderProps {
  inquiry: InquiryState;
  dispatch: Dispatch;
};

const InquirySender: React.FC<InquirySenderProps> = ({
  inquiry,
  dispatch
}) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.Inquiry.InquirySender', intl.formatMessage);

  const [inputValue, setInputValue] = useState<string>('');

  const send = async () => {
    const value = inputValue.trim();
    setInputValue('');
    if (!value) {
      message.warning(t('t0', '请输入内容'));
      return;
    }
    const content = JSON.stringify({
      type: 'text',
      value
    });
    dispatch({
      type: 'inquiry/sendMessage',
      payload: content,
      callback: (data) => {
        console.log(data);
      }
    })
  };

  const finish = () => {
    withModalRootContainer(Modal.confirm)({
      title: t('t1', '结束咨询'),
      content: t('t2', '时间未到，是否马上结束咨询？'),
      onOk: () => {
        dispatch({ type: 'inquiry/finish' })
      }
    })
  };

  return (
    <div className={styles.sender}>
      <div className={styles.toolBar}>
        <Space size={22}>
          <Upload
            accept="image/*"
            showUploadList={false}
            customRequest={(option) => dispatch({ type: 'inquiry/sendImage', payload: option.file })}
          >
            <IconFont className={styles.icon} type="hc-icon-tupian"/>
          </Upload>
          {
            (inquiry.countdown && inquiry.countdown > 0)
              ? <IconFont
                  type="hc-icon-kaiguan"
                  className={styles.icon}
                  onClick={finish}
                />
              : null
          }
        </Space>
      </div>
      <div className={styles.inputArea}>
        <TextArea
          placeholder={t('t3', "Enter 发送，Shift+Enter 换行")}
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyPress={e => {
            if (e.code.toUpperCase() === 'ENTER') {
              if (!e.shiftKey) {
                send();
                e.preventDefault();
              }
            }
          }}
        />
      </div>
    </div>
  )
};

const mapToProps = ({ inquiry }: { inquiry: InquiryState }) => {
  return {
    inquiry
  }
}
                  
export default connect(mapToProps)(InquirySender);
